import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http';

export const CoreSearchApiService = Symbol('CoreSearchApiService');

export type CoreSearchApiService = PsHttpService;

export interface ApiTranslateSpecificFieldRequest {
    patent_ids: string[];
    fields: string[];
    trans_lang: string
}

export type ApiTranslateSpecificFieldResponse = {
    patent_id: string;
    title: string;
    title_lang: string;
    title_tran?: string;
    title_tran_lang?: string;
}[]

export const TranslateSpecificField = Symbol('TranslateSpecificField');

export interface TranslateSpecificField {
    translateSpecificField(options: ApiTranslateSpecificFieldRequest): Promise<ApiTranslateSpecificFieldResponse>
}

export const SearchSettingLanguage = Symbol('SearchSettingLanguage');

export type ApiSearchSettingLanguageRequest = {
    source: 'workspace';
    workspace_id: string;
} | {
    source: 'analytics';
}

export type ApiSearchSettingLanguageResponse = {
    language: 'default' | 'JP' | 'EN' | 'CN';
}

export interface SearchSettingLanguage {
    getSelectedLanguage(data: ApiSearchSettingLanguageRequest): Promise<ApiSearchSettingLanguageResponse>;
}

export interface ApiFetchCompareInitRequest {
    type?: string;
    patent_ids?: string[];
    related_id?: string;
    family_type?: string;
    affect_type?: string;
    sort_order?: string;
    sort_type?: string;
}

export interface ApiFetchCompareInitResponse {
    finished: boolean;
    compare_id: string;
    src_patent_id?: string;
    src_text?: string;
    src_text_lang?: string;
}

export const FetchCompareInit = Symbol('FetchCompareInit');
export interface FetchCompareInit {
    fetchCompareInit(data: ApiFetchCompareInitRequest): Promise<ApiFetchCompareInitResponse>;
}

export interface ApiGetCompareListRequest {
    compareId: string;
    rows: number;
    page: number;
    sort?: string;
}

export interface ApiGetCompareListResponse {
    totalPages: number;
    totalNumber: number;
    currentPatentId: string;
    efqString: string;
    queryString: string;
    name: string;
    page: number;
    rows: number;
    LIST: {
        PATENT_ID: string;
        PN: string;
        TITLE: string;
    }[];
}

export const GetCompareList = Symbol('GetCompareList');
export interface GetCompareList {
    getCompareList(data: ApiGetCompareListRequest): Promise<ApiGetCompareListResponse>;
}


export interface ApiGetCompareOverviewRequest {
    compare_id: string;
    target_patent_id: string;
    src_patent_id?: string;
    tech_text_list?: string[];
    compare_lang?: string;
    text_compare_lang?: {
        desc?:string;
        clms?:string;
    }
}

export interface CompareResultList {
    src: {
        PN: string;
        similar_part: string;
        field_type: string;
    };
    target: {
        PN: string;
        similar_part: string;
        field_type: string;
    }[];
    similarity: number;
    part_id: number;
    paragraph_id: string;
}
export interface CompareTextLang {
    desc?:string;
    clms?:string
}

export interface ApiGetCompareOverviewResponse {
    compare_with: CompareResultList[];
    basic_info: {
        compare_lang: string;
        text_compare_lang?: CompareTextLang;
        src_replace_id: string;
        src_patent_id: string;
        src_text_translation: boolean;
        target_patent_id: string;
        target_text_translation: false;
        target_replace_id: string;
        target_pn: string;
    }
}

export const GetCompareOverview = Symbol('GetCompareOverview');
export interface GetCompareOverview {
    getCompareOverview(data:ApiGetCompareOverviewRequest): Promise<ApiGetCompareOverviewResponse>;
}

export interface ApiGetCompareTextRequest {
    compare_id: string;
}

export interface ApiGetCompareTextResponse {
    tech_text_list: string[];
}

export const GetCompareText = Symbol('GetCompareText');
export interface GetCompareText {
    getCompareText(data:ApiGetCompareTextRequest): Promise<ApiGetCompareTextResponse>;
}

export interface ApiSearchComparePatentRequest {
    q: string;
    simple: boolean;
}

export interface ComparePatentInfo {
    PATENT_ID: string;
    PN: string;
    TITLE: string;
    LEGAL_STATUS: number[];
}
export interface ApiSearchComparePatentResponse {
    patent_info: ComparePatentInfo;
}

export const SearchComparePatent = Symbol('SearchComparePatent');
export interface SearchComparePatent {
    searchComparePatent(data:ApiSearchComparePatentRequest): Promise<ApiSearchComparePatentResponse>;
}

export interface ApiAddComparePatentRequest {
    compare_id: string;
    patent_id: string;
}

export interface ApiAddComparePatentResponse {
    patent_info: ComparePatentInfo;
}
export const AddComparePatent = Symbol('AddComparePatent');

export interface AddComparePatent {
    addComparePatent(data:ApiAddComparePatentRequest): Promise<ApiAddComparePatentResponse>;
}

export interface ApiGetComparePatentTextRequest {
    compare_id: string;
    patent_id: string;
    lang: string;
    field_type: string,
    overview_request?: ApiGetCompareOverviewRequest
}

export interface ApiGetComparePatentTextResponse {
    DESC: string;
    DESC_LANG: string;
    DESC_SECTIONS: string[];
    DESC_SOURCE?: {
        isOCR: boolean
    };
    CLMS: string;
    CLMS_SOURCE: {
        isOCR: boolean
    };
    CLMS_TRAN_LANG: string
}

export const GetComparePatentText = Symbol('GetComparePatentText');

export interface GetComparePatentText {
    getComparePatentText(data:ApiGetComparePatentTextRequest): Promise<ApiGetComparePatentTextResponse>;
}
